import { Link } from 'react-router-dom'
import { Home } from 'lucide-react'

export default function Privacy() {
  return (
    <div className="min-h-screen bg-black text-white" style={{ background: '#000000' }}>
      <nav className="px-6 py-4 border-b border-gray-800">
        <div className="max-w-7xl mx-auto flex items-center gap-4">
          <Link to="/" className="text-gray-400 hover:text-white transition-colors">
            <Home className="w-6 h-6" />
          </Link>
          <h1 className="text-2xl font-bold text-white">Privacy Policy</h1>
        </div>
      </nav>
      
      <div className="max-w-4xl mx-auto px-8 py-12">
        <div className="stat-card rounded-2xl p-8 border space-y-6">
          <h2 className="text-3xl font-bold text-white mb-6">Privacy Policy</h2>
          
          <div>
            <h3 className="text-xl font-bold text-white mb-3">Information We Collect</h3>
            <p className="text-gray-400 leading-relaxed">
              When you sign in with Google OAuth, we collect your email address and username to provide you with a personalized typing practice experience. We also store your typing statistics including words per minute (WPM), accuracy, and progress through the alphabet lessons.
            </p>
          </div>
          
          <div>
            <h3 className="text-xl font-bold text-white mb-3">How We Use Your Data</h3>
            <p className="text-gray-400 leading-relaxed">
              Your data is used solely to track your typing progress and provide you with personalized recommendations. We do not share your personal information with third parties or use it for marketing purposes.
            </p>
          </div>
          
          <div>
            <h3 className="text-xl font-bold text-white mb-3">Data Security</h3>
            <p className="text-gray-400 leading-relaxed">
              We use Supabase for secure data storage and authentication. All data is encrypted and stored securely. You can delete your account and all associated data at any time by contacting us.
            </p>
          </div>
          
          <div>
            <h3 className="text-xl font-bold text-white mb-3">Cookies</h3>
            <p className="text-gray-400 leading-relaxed">
              We use essential cookies to maintain your login session. No tracking or advertising cookies are used.
            </p>
          </div>
          
          <Link to="/" className="btn-secondary inline-block mt-6">
            Back to Practice
          </Link>
        </div>
      </div>
    </div>
  )
}
